import BillingsOrderForwardBillingsDownloadParams, {
  BillingsOrderForwardBillingsDownloadParamsOrder,
} from "../../../../../../common/services/billings/order-forward-billings/download/billings-order-forward-billings-download-params";
import BillingStatus from "../../../../../../common/types/billing-status";
import BillingsTaxiTransferredOrderListingFilter, {
  BillingsTaxiTransferredOrderListingConsumerTaxiFilter,
  BillingsTaxiTransferredOrderListingInternalOrderIdFilter,
  BillingsTaxiTransferredOrderListingOrderStartDateFilter,
  BillingsTaxiTransferredOrderListingProducerTaxiFilter,
  BillingsTaxiTransferredOrderListingStatusFilter,
} from "../types/billings-taxi-transferred-order-listing-filter";
import BillingsTaxiTransferredOrderListingFilterType from "../types/billings-taxi-transferred-order-listing-filter-type";
import BillingsTaxiTransferredOrderListingItemBillingStatus from "../types/billings-taxi-transferred-order-listing-item-billing-status";
import BillingsTaxiTransferredOrderListingSortKey from "../types/billings-taxi-transferred-order-listing-sort-key";

const createStatus = (
  status: BillingsTaxiTransferredOrderListingItemBillingStatus | undefined,
): BillingStatus | undefined => {
  switch (status) {
    case BillingsTaxiTransferredOrderListingItemBillingStatus.ACCEPTED:
      return BillingStatus.ACCEPTED;
    case BillingsTaxiTransferredOrderListingItemBillingStatus.CREATED:
      return BillingStatus.CREATED;
    case BillingsTaxiTransferredOrderListingItemBillingStatus.REJECTED:
      return BillingStatus.REJECTED;
    case BillingsTaxiTransferredOrderListingItemBillingStatus.REOPENED:
      return BillingStatus.REOPENED;
    case BillingsTaxiTransferredOrderListingItemBillingStatus.REOPEN_REQUEST:
      return BillingStatus.REOPEN_REQUEST;
    default:
      return undefined;
  }
};

const createRequestOrder = (
  sortKey: BillingsTaxiTransferredOrderListingSortKey | null,
): BillingsOrderForwardBillingsDownloadParamsOrder | undefined => {
  const options: {
    sortKey: BillingsTaxiTransferredOrderListingSortKey;
    requestOrder: BillingsOrderForwardBillingsDownloadParamsOrder;
  }[] = [
    {
      requestOrder: BillingsOrderForwardBillingsDownloadParamsOrder.DATE_AT_ASC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.ORDER_START_DATE_ASC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.DATE_AT_DESC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.ORDER_START_DATE_DESC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.HUMAN_ID_ASC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.INTERNAL_ORDER_ID_ASC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.HUMAN_ID_DESC,
      sortKey:
        BillingsTaxiTransferredOrderListingSortKey.INTERNAL_ORDER_ID_DESC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.DISTANCE_DESC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.DISTANCE_DESC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.DISTANCE_ASC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.DISTANCE_ASC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.DISTANCE_RATE_ASC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.DISTANCE_RATE_ASC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.DISTANCE_RATE_DESC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.DISTANCE_RATE_DESC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.DISTANCE_AMOUNT_ASC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.DISTANCE_COST_ASC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.DISTANCE_AMOUNT_DESC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.DISTANCE_COST_DESC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.HALTING_AMOUNT_ASC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.STOPOVER_COST_ASC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.HALTING_AMOUNT_DESC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.STOPOVER_COST_DESC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.HIGHWAY_CHARGE_ASC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.TOLL_ROADS_COST_ASC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.HIGHWAY_CHARGE_DESC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.TOLL_ROADS_COST_DESC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.TOTAL_AMOUNT_ASC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.TOTAL_COST_ASC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.TOTAL_AMOUNT_DESC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.TOTAL_COST_DESC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.PRODUCER_ASC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.PRODUCER_ASC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.PRODUCER_DESC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.PRODUCER_DESC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.CONSUMER_ASC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.CONSUMER_ASC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.CONSUMER_DESC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.CONSUMER_DESC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.BILLING_MODEL_ASC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.BILLING_MODEL_ASC,
    },
    {
      requestOrder:
        BillingsOrderForwardBillingsDownloadParamsOrder.BILLING_MODEL_DESC,
      sortKey: BillingsTaxiTransferredOrderListingSortKey.BILLING_MODEL_DESC,
    },
  ];

  return options.find((option) => option.sortKey === sortKey)?.requestOrder;
};

const createRequest = (
  taxiCorporationId: string | undefined,
  filters: BillingsTaxiTransferredOrderListingFilter[],
  sortKey: BillingsTaxiTransferredOrderListingSortKey | null,
): BillingsOrderForwardBillingsDownloadParams => {
  return {
    order: createRequestOrder(sortKey),
    taxiCorporationId: taxiCorporationId,
    humanId: filters.find(
      (filter) =>
        filter.type ===
        BillingsTaxiTransferredOrderListingFilterType.INTERNAL_ORDER_ID,
    )?.value as
      | BillingsTaxiTransferredOrderListingInternalOrderIdFilter["value"]
      | undefined,
    producer: filters.find(
      (filter) =>
        filter.type ===
        BillingsTaxiTransferredOrderListingFilterType.PRODUCER_TAXI,
    )?.value as
      | BillingsTaxiTransferredOrderListingProducerTaxiFilter["value"]
      | undefined,
    consumer: filters.find(
      (filter) =>
        filter.type ===
        BillingsTaxiTransferredOrderListingFilterType.CONSUMER_TAXI,
    )?.value as
      | BillingsTaxiTransferredOrderListingConsumerTaxiFilter["value"]
      | undefined,
    startTimeSince: (
      filters.find(
        (filter) =>
          filter.type ===
          BillingsTaxiTransferredOrderListingFilterType.ORDER_START_DATE,
      )?.value as
        | BillingsTaxiTransferredOrderListingOrderStartDateFilter["value"]
        | undefined
    )?.from.toJSON(),
    startTimeTo: (
      filters.find(
        (filter) =>
          filter.type ===
          BillingsTaxiTransferredOrderListingFilterType.ORDER_START_DATE,
      )?.value as
        | BillingsTaxiTransferredOrderListingOrderStartDateFilter["value"]
        | undefined
    )?.to.toJSON(),
    status: createStatus(
      filters.find(
        (filter) =>
          filter.type ===
          BillingsTaxiTransferredOrderListingFilterType.BILLING_STATUS,
      )?.value as
        | BillingsTaxiTransferredOrderListingStatusFilter["value"]
        | undefined,
    ),
  };
};

const BillingsOrderForwardDownloadParamsFactory = {
  createRequest,
};

export default BillingsOrderForwardDownloadParamsFactory;
